/**
 * Pricing JS - loads on Home and Pricing page
 */

import axios from 'axios'
import Pricing from '@siteminder/pricing-api'
import './anchor-scroll-offset.js'
import pageLang from '../util/pageLang.js'

export default {
  init() {
    class Price {
      constructor(translations) {
        this.lang = pageLang
        this.translations = translations
        this.$pricing = new Pricing()
        this.$pricing.init()
        this.subregion = null
        this.rooms = 5
        this.toggleFeatures()
        window.btnClick = function (e) {
          e.stopPropagation()
        }
        // slow as this is a promise, it needs the others init first
        this.endpoint = 'https://resources.siteminder.com/services/geo/index.php'
        this.request()
      }

      request() {
        axios.get(this.endpoint)
          .then((response) => {
            if (response.data.request && response.data.request.status) {
              console.log('GeoIP API available')
              this.region = response.data.location.region.pricing.toLowerCase()
              this.country = response.data.location.country.code.toLowerCase()

              if (this.getTheRegion(this.country) == false) {
                if (this.region === 'uk') {
                  this.region = 'emea'
                  this.subregion = response.data.location.region.subregion
                  this.getThePrice(this.region, this.country, this.subregion)

                } else if (this.region === 'emea' || this.region === 'apac') { // pricing region emea pass subregion
                  this.subregion = response.data.location.region.subregion
                  this.getThePrice(this.region, this.country, this.subregion)

                } else { // subregion null for the red -- set at the top
                  this.getThePrice(this.region, this.country, this.subregion)
                }
              } else {
                this.region = this.getTheRegion(this.country)
                this.getThePrice(this.region, this.country, this.subregion)
              }
            } else {
              console.warn('GeoIP API unavailable. Defaulting request.')
              this.country = 'us'
              this.region = 'amer'
              this.getThePrice(this.region, this.country, this.subregion)
            }
          })
          .catch((e) => {
            console.warn('GeoIP API error. Defaulting request.', e)
            this.country = 'us'
            this.region = 'amer'
            this.getThePrice(this.region, this.country, this.subregion)
          })
      }

      // Custom regions
      getTheRegion(country) {
        const countryMap = {
          id: 'asiaidr',
          th: 'asiathb',
          my: 'asiadev',
        }
        return countryMap[country] || false
      }

      // Get the final price
      getThePrice(region, country, subregion) {
        // Initial quote when page loads for 5rooms
        let roomInput = document.querySelector('.input-number')
        let roomInputs = document.querySelectorAll('.input-number')
        if (roomInput) {
          this.rooms = parseInt(roomInput.value)
        }
        this.bindPriceURLs(region, country, this.rooms, subregion)

        // Room number inc-dec buttons
        const btnnumbers = document.querySelectorAll('.btn-number')
        btnnumbers.forEach((btnnumber) => {
          btnnumber.addEventListener('click', () => {
            this.rooms = parseInt(roomInput.value)
            this.bindPriceURLs(region, country, this.rooms, subregion)
          })
        })

        // Room number input
        roomInputs.forEach((roomInput) => {
          roomInput.addEventListener('keyup', () => {
            this.rooms = parseInt(roomInput.value)
            if (!isNaN(this.rooms)) {
              this.bindPriceURLs(region, country, this.rooms, subregion)
            }
          })
        })
      }

      bindPriceURLs(region, country, rooms, subregion) {
        this.quote(region, country, subregion)
        this.updateURL(rooms)
      }

      // Get the quote
      quote(region, country, subregion) {
        this.$pricing.ready(() => {
          const products = document.querySelectorAll('[data-field="product"]')
          products.forEach((product) => {
            const productname = product.getAttribute('id')
            var price = this.$pricing.lookups({
              rooms: this.rooms,
              product: productname,
              region: region,
              subregion: subregion,
              term: 'monthly',
              format: 'SHORT',
            }, 'products')
            const output = product.querySelector('.output')
            const priceTermLHB = document.querySelector('#term.lh-basic')
            const priceTermLHPro = document.querySelector('#term.lh')
            if (output.classList.contains('lh-flex')) {
              output.innerHTML = this.translations.notAvailable
            } else if (this.rooms === 0) {
              if (region === 'emea') {
                if (subregion === 'United Kingdom') {
                  output.innerHTML = '£__'
                } else {
                  output.innerHTML = '€__'
                }
              } else {
                output.innerHTML = '$__'
              }
            } else {
              if (price === -1) {
                if (output.classList.contains('lh-basic')) {
                  output.innerHTML = this.translations.notAvailable
                  if (priceTermLHB && !priceTermLHB.classList.contains('d-none')) {
                    priceTermLHB.classList.add('d-none')
                  }
                } else {
                  output.innerHTML = this.translations.contactSales
                  if (priceTermLHPro && !priceTermLHPro.classList.contains('d-none')) {
                    priceTermLHPro.classList.add('d-none')
                  }
                }
              } else if (price === 0) {
                output.innerHTML = 'Free'
              } else {
                if (priceTermLHB) {
                  priceTermLHB.classList.remove('d-none')
                }
                if (priceTermLHPro) {
                  priceTermLHPro.classList.remove('d-none')
                }
                output.innerHTML = price
                if (region === 'emea') {
                  // No currency code for EMEA (EUR)
                  output.innerHTML = price
                } else if (region === 'asiaidr') {
                  output.innerHTML = this.formatNumberIDR(price)
                } else if (region === 'asiathb') {
                  output.innerHTML = this.formatNumber(price)
                } else {
                  output.innerHTML = price + '<span class="ml-2"><strong>' + this.getRegionsCurrencyCode(region, country, subregion) + '</strong></span>'
                }
              }
            }
          })

          // Dynamically add currency to LHB Booking Value Tooltip
          const lhbBkVtooltips = document.querySelectorAll('.lhbBkVTooltip')
          lhbBkVtooltips.forEach((tooltip) => {
            var tooltipAttrVal = tooltip.getAttribute('data-original-title')
            if (region === 'emea') {
              if (subregion !== 'United Kingdom') {
                tooltipAttrVal = tooltipAttrVal.replace(/\$1000/g, '1000 €');
                tooltipAttrVal = tooltipAttrVal.replace(/\$10/g, '10 €');
                tooltip.setAttribute('data-original-title', tooltipAttrVal)
              } else {
                tooltipAttrVal = tooltipAttrVal.replace(/\$/g, '£');
                tooltip.setAttribute('data-original-title', tooltipAttrVal)
              }
            }
          })

          const signs = document.querySelectorAll('[data-field="sign"]')
          signs.forEach((sign) => {
            if (sign) {
              const outputSign = sign.querySelector('.output-sign')
              if (subregion === 'United Kingdom') {
                outputSign.innerHTML = '£'
              } else {
                outputSign.innerHTML = '$'
              }
            }
          })
        })
      }

      getRegionsCurrencyCode(region, country, subregion) {
        const codes = {
          apac: 'AUD',
          emea: 'EUR',
          asia: 'USD',
          asiaidr: 'IDR',
          asiathb: 'THB',
          amer: 'USD',
          uk: 'GBP',
          nz: 'NZD',
        }

        // const GBPCountries = ['gb', 'za']
        const EMEAUSDCountries = ['br']
        const IDRCountry = ['id']
        const THBCountry = ['th']
        if (subregion === 'United Kingdom') {
          return codes.uk
        } else if (EMEAUSDCountries.indexOf(country) >= 0) {
          return codes.amer // emeausd code is 'USD'
        } else if (IDRCountry.indexOf(country) >= 0) {
          return codes.asiaidr
        } else if (THBCountry.indexOf(country) >= 0) {
          return codes.asiathb
        } else if (subregion === 'New Zealand & Pacific') {
          return codes.nz
        } else {
          return codes[region] || codes.amer
        }
      }

      updateURL(rooms) {
        const triggers = document.querySelectorAll('.btn-pricing')
        triggers.forEach((trigger) => {
          if (rooms === 0) {
            trigger.classList.add('disabled')
          } else {
            if (trigger.classList.contains('guided-selling')) { // LHB and LH Regular
              if (rooms > 30 && rooms <= 50) {
                if (trigger.classList.contains('free-trial')) {
                  trigger.classList.add('disabled')
                }
                if (trigger.classList.contains('enquire-now')) {
                  trigger.classList.remove('disabled')
                  let product = trigger.getAttribute('data-product')
                  let url = this.translations.freeTrialLink
                  trigger.addEventListener('click', (e) => {
                    e.preventDefault()
                    location.href = url + '?l='+ this.lang + '&rooms=' + rooms + '&p=' + product + '&r=' + rooms
                  })
                }
              } else if (rooms > 50) {
                if (trigger.classList.contains('free-trial')) {
                  trigger.classList.add('disabled')
                }
                if (trigger.classList.contains('enquire-now')) {
                  trigger.classList.remove('disabled')
                  trigger.addEventListener('click', (e) => {
                    e.preventDefault()
                    let url = this.translations.contactOver50Link
                    location.href = url + '?l='+ this.lang + '&rooms=' + rooms
                  })
                }
              } else {
                if (trigger.classList.contains('free-trial')) {
                  trigger.classList.remove('disabled')
                  let product = trigger.getAttribute('data-product')
                  let url = '/signup/index.php'
                  trigger.addEventListener('click', (e) => {
                    e.preventDefault()
                    location.href = url + '?l='+ this.lang + '&rooms=' + rooms + '&p=' + product + '&r=' + rooms
                  })
                }
                if (trigger.classList.contains('enquire-now')) {
                  trigger.classList.remove('disabled')
                  let product = trigger.getAttribute('data-product')
                  trigger.addEventListener('click', (e) => {
                    e.preventDefault()
                    let url = this.translations.freeTrialLink
                    location.href = url + '?l='+ this.lang + '&rooms=' + rooms + '&p=' + product + '&r=' + rooms
                  })
                }
              }
            } else { // LH Regular only
              trigger.classList.remove('disabled')
              if (rooms > 50) {
                trigger.addEventListener('click', (e) => {
                  e.preventDefault()
                  let url = this.translations.contactOver50Link
                  location.href = url + '?rooms=' + rooms
                })
                $('.btn-pricing').text(this.translations.enquireNow)
              } else {
                trigger.addEventListener('click', (e) => {
                  e.preventDefault()
                  let product = trigger.getAttribute('data-product')
                  let url = this.translations.freeTrialLink
                  location.href = url + '?l='+ this.lang + '&rooms=' + rooms + '&p=' + product + '&r=' + rooms
                })
                $('.btn-pricing').text(this.translations.tryFree)
                $('.btn-pricing.flexthid').text(this.translations.enquireNow)
              }
            }
            if (trigger.classList.contains('button-consultant')) {
              trigger.classList.remove('disabled')
              let url = this.translations.contactUsLink
              trigger.addEventListener('click', (e) => {
                e.preventDefault()
                location.href = url + '?rooms=' + rooms
              })
            }
          }
          if (trigger.classList.contains('button-consultant')) {
            trigger.classList.remove('disabled')
            let url = this.translations.contactUsLink
            trigger.addEventListener('click', (e) => {
              e.preventDefault()
              location.href = url + '?rooms=' + rooms
            })
          }
        })
      }

      // This button is available on mobile only.
      toggleFeatures() {
        let btnsMbFeatures = document.querySelectorAll('.btnShowHide')
        btnsMbFeatures.forEach((btnMbFeatures) => {
          btnMbFeatures.addEventListener('click', () => {
            if (btnMbFeatures.innerHTML === this.translations.showFeatures) {
              btnMbFeatures.innerHTML = this.translations.hideFeatures
            } else {
              btnMbFeatures.innerHTML = this.translations.showFeatures
            }
          })
        })
      }

      // formats currency on 1000 with '.' -- IDR
      formatNumberIDR(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }

      // formats currency on 1000 with ',' -- THB
      formatNumber(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
    const translations = window.pricingTranslations
    new Price(translations)
  },
  finalize() {},
};


// WEBPACK FOOTER //
// ./scripts/routes/pricing.js